module.exports = __webpack_public_path__ + "img/gomb-szolgaltat.e9dc9146.png";